const CryptoJS = require('crypto-js');

export const encrypt = text => {
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
};

export const decrypt = data => {
  return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
};

export const formatThousands = (num) => {
  let values = num.toString().split('.');
  return values[0].replace(/.(?=(?:.{3})+$)/g, '$&,') + (values.length === 2 ? '.' + values[1] : '')
}